class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"], input[name="language_code"]'),
      panel: this.querySelector('ul'),
    };

    this.elements.panel
      .querySelectorAll('a')
      .forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    const element = event.currentTarget !== null ? event.currentTarget : event.target;
    // prevent form submission and take the a href link instead when the element has the attribute data-with-link
    if (!element.hasAttribute('data-with-link')) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = element.dataset.value;
      if (form) form.submit();
    }
  }
}
customElements.define('localization-form', LocalizationForm);
